import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import { StripeCardElement } from '@stripe/stripe-js';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { notificationMessages } from '@care-portals/data';
import { environment } from '../../../../environments/environment';
import { AccountFacade } from '../../../+store/account/account.facade';
import { CommonModule } from '@angular/common';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { OrgStripeService } from '../../../services/org-stripe.service';

@Component({
  selector: 'add-stripe-payment-method',
  templateUrl: './add-stripe-payment-method.component.html',
  styleUrls: ['./add-stripe-payment-method.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    NzGridModule,
    NzSpinModule,
    FormsModule,
    ReactiveFormsModule,
    NzButtonModule
  ]
})
export class AddStripePaymentMethodComponent implements OnDestroy {
  @Input() hideAddButton?: boolean = false;
  @Output() paymentMethodAdded: EventEmitter<string> = new EventEmitter();

  card: StripeCardElement | null = null;
  loading$: Observable<boolean>;
  saving$: Observable<boolean>;
  
  paymentCardId: string = '';
  testEnv = !environment.production;

  destroy$ = new Subject<void>();

  constructor(
    private notification: NzNotificationService,
    private accountFacade: AccountFacade,
    private stripeService: OrgStripeService
  ) {
    this.accountFacade.paymentMethods$
      .pipe(takeUntil(this.destroy$))
      .subscribe(paymentMethods => {
        if (!paymentMethods.loading) {
          this.paymentMethodAdded.emit(this.paymentCardId);
        }
      });
  }

  ngAfterViewInit(): void {
    this.stripeService.initElements(card => {
      this.card = card;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addPayment(): void {
    if (!this.card) {
      this.notification.error(
        notificationMessages.PaymentFailed.title,
        'Payment card is not initialized. Please try again.'
      );
      return;
    }

    this.stripeService.tokenize().subscribe({
      next: paymentMethod => {
        this.paymentCardId = paymentMethod.id;
        this.paymentMethodAdded.emit(this.paymentCardId);
      },
      error: error => {
        console.error(error.message);
        this.notification.error(
          notificationMessages.PaymentFailed.title,
          error.message
        );
      }
    });
  }
}
